<div class="dialog-header" mat-dialog-title data-testid="confirm-dialog-title">
    @if (title) {
        <h4 class="ca-headline-4">
            {{ title }}
        </h4>
    }
    @if (titleElement) {
        <ng-container *ngTemplateOutlet="titleElement; context: { $implicit: context }"></ng-container>
    }
    <button mat-icon-button class="ca-button close-button" data-testid="confirm-dialog-close-btn" (click)="close()">
        <ca-icon icon="cross"></ca-icon>
    </button>
</div>
